var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HomeHero'),_c('HomeDetails'),_c('HomeRefs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }